export default "__VITE_ASSET__CHWw1WsY__"